import { LineItem } from "./lineItem";

export class SaleOrder {
  constructor(
    public id: number = null,
    public customer_id: number = null, // 77
    public assignedbyuser_id: number = null, // ligado a USERS
    public so: string = "pending",
    public clientuser_id: number = null, // ligado a USERS
    public rep_id: number = null, // ligado a USERS
    public customerName: string = "",
    public commentstocustomer: string = "",
    public conditions_id: string = "", // ligado a CONDITIONS
    public contactcontact: string = "",
    public contactcontactuser_id: number = null, // ligado a USERS
    public contactcompany: string = "",
    public contactemail: string = "",
    public contactfax: string = "",
    public contactphone: string = "",
    public contactaddress1: string = "",
    public contactaddress2: string = "",
    public contactcity: string = "",
    public contactstate: string = "",
    public contaccountry: string = "",
    public contactpostalcode: string = "",
    public currency: string = "USD",
    public datevoided: string = "",
    public description: string = "",
    public duedate: string = "",
    public date: string = '',

    public shipfromname: string = "",
    public shiptoname: string = "",

    public foreignamount: number = 0.0,
    public foreignfreight: number = 0.0,
    public foreigninstallcharge: number = 0.0,
    public foreignmisccharge: number = 0.0,
    public foreignstatetax: number = 0.0,
    public foreigntax1: number = 0.0,
    public foreigntax2: number = 0.0,
    public foreigntax3: number = 0.0,
    public foreigntotalsales: number = 0.0,
    public freight: number = 0.0,

    public internalcomments: string = "",
    public invoiceddate: string = "",
    public lastupdatedbyuser_id: number = null, // ligado a USERS
    public saledate: string = "",

    public setDefaultFromLocation: boolean = false,
    public shipfromlocation_id: string = null,
    public shipfromcompany: string = "",
    public shipfromcontactuser_id: number = null, // ligado a USERS
    public shipfromcontact: string = "",
    public shipfromemail: string = "",
    public shipfromfax: string = "",
    public shipfromphone: string = "",
    public shipfromaddress1: string = "",
    public shipfromaddress2: string = "",
    public shipfromcity: string = "",
    public shipfromstate: string = "",
    public shipfromcountry: string = "",
    public shipfrompostalcode: string = "",

    public shipstatus: string = "",

    public setDefaultToLocation: boolean = false,
    public shiptolocation_id: string = null,
    public shiptocompany: string = "",
    public shiptoclientuser_id: number = null, // ligado a USERS
    public shiptocontact: string = "",
    public shiptophone: string = "",
    public shiptoemail: string = "",
    public shiptofax: string = "",
    public shiptoaddress1: string = "",
    public shiptoaddress2: string = "",
    public shiptocity: string = "",
    public shiptostate: string = "",
    public shiptocountry: string = "",
    public shiptopostalcode: string = "",

    public promiseDate: string = "",
    public hideline: number = 0,
    public subtotal: number = 0.0,
    public servichesCharge: number = 0.0,
    public misCcharge: number = 0.0,
    public grossMargin: number = 0.0,
    public marginPercentage: number = 0.0,

    public status: string = "Open",
    public extendedcost: number = 0.0,
    public extracost: number = 0.0,
    public tax: number = 0.0,
    public total: number = 0.0,
    public state_tax: number = null,
    public taxauthority: string = "", // pendiente

    public client_PO_Number: string = "",
    public term: number = null,
    public vendorso: string = "",
    public voidafter: string = "",
    public probabilityFactor: number = null,
    public sp = null,
    public clientPoNumber = "",

    public lineItems: Array<LineItem> = [],
    public create_on_iq: number = 0,
    public warehouse_id: number = null,
    public reference: string = "",
    public profit: any = 0.00,
    public customer: string = "",
    public cleartax: number = 0,
    public taxConfig: any = []
  ) {
  
  }

  setValues(response) {
    console.log("saleOrder setValues response => ", response);
    this.id = response.data.id;
    this.assignedbyuser_id = response.data.assignedby; // ligado a USERS
    // this.customer_id = response.data.customerTable.id;
    this.so = response.data.so;
    this.sp = response.data.sp;
    this.vendorso = response.data.vendorso;
    this.clientPoNumber = response.data.clientPoNumber;
    this.extendedcost = response.data.extendedcost;
    this.extracost = Number(response.data.extracost);
    this.state_tax =
      response.data.state !== null ? response.data.state.id : null;
    if (response.data.customerTable != null) {
      this.customer_id = response.data.customerTable.id;
      this.customerName =
        response.data.customerTable.name +
        " " +
        response.data.customerTable.surname;
    } else {
      this.customer_id = null;
      this.customerName = "";
    }
    if (response.data.rep != null) {
      this.rep_id = response.data.rep.id;
    } else {
      this.rep_id = null; // ligado a USERS
    }

    this.commentstocustomer = response.data.commentstocustomer;
    this.conditions_id =
      response.data.conditions != null ? response.data.conditions.id : ""; // ligado a CONDITIONS
    this.contactcontact = response.data.contactcontact;
    this.contactcontactuser_id =
      response.data.contactcontactuser !== null
        ? response.data.contactcontactuser.id
        : null; // ligado a USERS
    this.contactemail = response.data.contactemail;
    this.contactfax = response.data.contactfax;
    this.contactphone = response.data.contactphone;
    this.currency = response.data.currency;
    this.datevoided =
      response.data.datevoided !== null
        ? this.getFecha(new Date(response.data.datevoided.timestamp * 1000))
        : null;
    this.description = response.data.description;
    if (response.data.duedate !== null) {
      this.duedate = this.getFecha(
        new Date(response.data.duedate.timestamp * 1000)
      );
    }

    this.date = String(response.data.saledate).split(" ")[0];

    this.foreignamount = response.data.foreignamount;
    this.foreignfreight = response.data.foreignfreight;
    this.foreigninstallcharge = response.data.foreigninstallcharge;
    this.foreignmisccharge = response.data.foreignmisccharge;
    this.foreignstatetax = response.data.foreignstatetax;
    this.foreigntax1 = response.data.foreigntax1;
    this.foreigntax2 = response.data.foreigntax2;
    this.foreigntax3 = response.data.foreigntax3;
    this.foreigntotalsales = response.data.foreigntotalsales;
    this.freight = response.data.freight;

    this.internalcomments = response.data.internalcomments;
    if (response.data.invoiceddate !== null) {
     /* this.invoiceddate = this.getFecha(
        new Date(response.data.invoiceddate.timestamp * 1000)
      );*/
    }
    this.invoiceddate = response.data.invoiceddate?.split(' ')[0];
    this.lastupdatedbyuser_id = response.data.lastupdatedby; // ligado a USERS
    /*if (response.data.saledate !== null) {
      this.saledate = this.getFecha(
        new Date(response.data.saledate.timestamp * 1000)
      );
    }*/
     this.saledate = String(response.data.saledate).split(" ")[0];
    
    this.shipfromcompany = response.data.shipfromcompany;
    this.shipfromcontactuser_id = null; // ligado a USERS
    this.shipfromlocation_id = response.data.shipFromLocationId;
    this.shipfromcontact = response.data.shipfromcontact;
    this.shipfromemail = response.data.shipfromemail;
    this.shipfromfax = response.data.shipfromfax;
    this.shipfromphone = response.data.shipfromphone;
    this.shipfromaddress1 = response.data.shipfromaddress1;
    this.shipfromaddress2 = response.data.shipfromaddress2;
    this.shipfromcity = response.data.shipfromcity;
    this.shipfromstate = response.data.shipfromstate;
    this.shipfromcountry = response.data.shipfromcountry;
    this.shipfrompostalcode = response.data.shipfrompostalcode;

    this.shipstatus = response.data.shipstatus;

    this.shiptocompany = response.data.shiptocompany;
    this.shiptoclientuser_id = null; // ligado a USERS
    this.shiptolocation_id = response.data.shipToLocationId;
    this.shiptocontact = response.data.shiptocontact;
    this.shiptophone = response.data.shiptophone;
    this.shiptoemail = response.data.shiptoemail;
    this.shiptofax = response.data.shiptofax;
    this.shiptoaddress1 = response.data.shiptoaddress1;
    this.shiptoaddress2 = response.data.shiptoaddress2;
    this.shiptocity = response.data.shiptocity;
    this.shiptostate = response.data.shiptostate;
    this.shiptocountry = response.data.shiptocountry;
    this.shiptopostalcode = response.data.shiptopostalcode;
    this.customerName = '';
    if(response.data.customerTable && response.data.customerTable.companyLinked)
      this.customerName =  response.data.customerTable.companyLinked.name;

    this.contactcompany = response.data.contactcompany;
    this.contactaddress1 = response.data.contactaddress1;
    this.contactaddress2 = response.data.contactaddress2;
    this.contactcity = response.data.contactcity;
    this.contactstate = response.data.contactstate;
    this.contaccountry = response.data.contactcountry;
    this.contactpostalcode = response.data.contactpostalcode;
    this.promiseDate = response.data.promiseDate;
    this.hideline = response.data.hideline;
    this.subtotal = response.data.subtotal;
    this.servichesCharge = response.data.servichesCharge;
    this.misCcharge = response.data.misCcharge;
    this.grossMargin = response.data.grossMargin;
    this.marginPercentage = response.data.marginPercentage;

    this.status = response.data.status;
    this.tax = response.data.tax;
    this.taxauthority = response.data.taxauthority; // pendiente
    this.total = response.data.total;
    if (response.data.term !== null) {
      this.term = response.data.term.id;
    }
    this.client_PO_Number = response.data.clientPoNumber;
    this.profit = response.data.profit;
    // this.lineItems = response.lineItems;
    this.customer = response.data.customer;
    this.cleartax = response.data.cleartax;
    this.taxConfig = response.data.taxConfig;
  }

  saveJson() {
    return {
      id: this.id,
      assignedbyuser_id: this.assignedbyuser_id,
      so: this.so,
      clientuser_id: this.clientuser_id,
      rep_id: this.rep_id,
      customerName: this.customerName,
      commentstocustomer: this.commentstocustomer,
      conditions_id: this.conditions_id,
      contactcontact: this.contactcontact,
      contactcontactuser_id: this.contactcontactuser_id,
      contactemail: this.contactemail,
      contactfax: this.contactfax,
      contactphone: this.contactphone,
      contactcompany: this.contactcompany,
      contactaddress1: this.contactaddress1,
      contactaddress2: this.contactaddress2,
      contactcity: this.contactcity,
      contactstate: this.contactstate,
      contaccountry: this.contaccountry,
      contactpostalcode: this.contactpostalcode,
      currency: this.currency,
      datevoided: this.datevoided,
      description: this.description,
      duedate: this.duedate,
      clientPoNumber: this.clientPoNumber,

      shipfromname: this.shipfromname,
      shiptoname: this.shiptoname,

      foreignamount: this.foreignamount,
      foreignfreight: this.foreignfreight,
      foreigninstallcharge: this.foreigninstallcharge,
      foreignmisccharge: this.foreignmisccharge,
      foreignstatetax: this.foreignstatetax,
      foreigntax1: this.foreigntax1,
      foreigntax2: this.foreigntax2,
      foreigntax3: this.foreigntax3,
      foreigntotalsales: this.foreigntotalsales,
      freight: this.freight,

      internalcomments: this.internalcomments,
      invoiceddate: this.invoiceddate,
      lastupdatedbyuser_id: this.lastupdatedbyuser_id,
      saledate: this.saledate,

      setDefaultFromLocation: this.setDefaultFromLocation,
      shipfromlocation_id: this.shipfromlocation_id,
      shipfromcompany: this.shipfromcompany,
      shipfromcontactuser_id: this.shipfromcontactuser_id,
      shipfromcontact: this.shipfromcontact,
      shipfromemail: this.shipfromemail,
      shipfromfax: this.shipfromfax,
      shipfromphone: this.shipfromphone,
      shipfromaddress1: this.shipfromaddress1,
      shipfromaddress2: this.shipfromaddress2,
      shipfromcity: this.shipfromcity,
      shipfromstate: this.shipfromstate,
      shipfromcountry: this.shipfromcountry,
      shipfrompostalcode: this.shipfrompostalcode,

      shipstatus: this.shipstatus,

      setDefaultToLocation: this.setDefaultToLocation,
      shiptolocation_id: this.shiptolocation_id,
      shiptocompany: this.shiptocompany,
      shiptoclientuser_id: this.shiptoclientuser_id,
      shiptocontact: this.shiptocontact,
      shiptophone: this.shiptophone,
      shiptoemail: this.shiptoemail,
      shiptofax: this.shiptofax,
      shiptoaddress1: this.shiptoaddress1,
      shiptoaddress2: this.shiptoaddress2,
      shiptocity: this.shiptocity,
      shiptostate: this.shiptostate,
      shiptocountry: this.shiptocountry,
      shiptopostalcode: this.shiptopostalcode,

      promiseDate: this.promiseDate,
      hideline: this.hideline,
      subtotal: this.subtotal,
      servichesCharge: this.servichesCharge,
      misCcharge: this.misCcharge,
      grossMargin: this.grossMargin,
      marginPercentage: this.marginPercentage,

      status: this.status,
      tax: this.tax,
      taxauthority: this.taxauthority,
      total: this.total,

      client_PO_Number: this.client_PO_Number,
      term: this.term
    };
  }

  private getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();
    return anio + "-" + month + "-" + day;
  }
}
